import { useContext, useEffect } from 'react'
import { ConferenceContext } from 'contexts/conference'
import { SubsessionStatus } from 'zoom/subsessionSdkEnums'

const useTabClose = (): void => {
    const conference = useContext(ConferenceContext)

    useEffect(() => {
        const onBeforeUnload = (): void => {
            if (conference.status !== 'session-joined') {
                return
            }

            const subsessionClient = conference.rtcSession.getSubsessionClient?.()

            // Check if user is in an active subsession
            const currentSub = subsessionClient?.getCurrentSubsession?.()
            const subsessionStatus = subsessionClient?.getSubsessionStatus?.()

            const isInSubsession = currentSub?.subsessionId &&
                subsessionStatus !== SubsessionStatus.NotStarted &&
                subsessionStatus !== SubsessionStatus.Closed

            if (isInSubsession) {
                // Don't leave - preserve subsession state for quick rejoin
                return
            }

            // Safe to leave - not in subsession
            conference.rtcSession.leave().catch(error => {
                console.warn('[useTabClose] Error leaving session:', error)
            })
        }

        window.addEventListener('beforeunload', onBeforeUnload)

        return () => {
            window.removeEventListener('beforeunload', onBeforeUnload)
        }
    }, [conference])
}
export { useTabClose }
